import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "property-default" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_choice_toggle = _resolveComponent("ontos-choice-toggle")!
  const _component_ontos_instance_property_input = _resolveComponent("ontos-instance-property-input")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ontos_choice_toggle, {
      "model-value": _ctx.mode,
      label: _ctx.$tt('default-value'),
      options: _ctx.modes,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.choose($event)))
    }, null, 8, ["model-value", "label", "options"]),
    (_ctx.mode === 'fixed')
      ? (_openBlock(), _createBlock(_component_ontos_instance_property_input, {
          key: 0,
          class: _normalizeClass(["property-default-field", {'property-default-field--wide': _ctx.wide}]),
          property: _ctx.field,
          value: _ctx.fixedValue,
          domain: _ctx.candidates,
          options: _ctx.options,
          "system-alias": _ctx.systemAlias,
          "idea-alias": _ctx.ideaAlias,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFixed($event))),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFixed($event)))
        }, null, 8, ["class", "property", "value", "domain", "options", "system-alias", "idea-alias"]))
      : (_ctx.mode === 'formula')
        ? (_openBlock(), _createBlock(_component_ontos_formula_input, _mergeProps({
            key: 1,
            ref: "editor",
            class: "required property-default-formula"
          }, _ctx.bindings, {
            label: _ctx.$tt('default-mode.formula'),
            value: _ctx.formula,
            "default-formula": "",
            draft: _ctx.draft,
            "result-label": _ctx.resultLabel,
            example: _ctx.example,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('input', {formula: $event})))
          }), null, 16, ["label", "value", "draft", "result-label", "example"]))
        : _createCommentVNode("", true)
  ]))
}